<template>
  <div>
    <a-tabs defaultActiveKey="3" :class="$style.tabs">
      <a-tab-pane tab="Videos" key="1">
        <div v-if="creator.videos.videos.length" class="long-videos">
          <div class="long-video-section">
            <router-link
              v-for="video in creator.videos.videos"
              :key="video.videoID"
              :to="{
                    name: 'video-details',
                    params: { video, videoID: video.videoID },
                  }"
              class="long-video-container"
            >
              <div class="long-thumbnail">
                <img :src="video.data.thumbnail" class="long-thumbnail-image" />
              </div>
              <div class="long-video-right-section">
                <div class="long-video-title">{{ video.data.title }}</div>
                <div class="video-metadata">
                  <span v-if="!video.data.titleComplete">Create title</span>
                  <span v-else-if="!video.data.thumbnailComplete">Create thumbnail</span>
                  <span v-else-if="!video.data.scriptComplete">Write script</span>
                  <span v-else-if="!video.data.filmComplete">Ready to film</span>
                  <span v-else-if="!video.data.editComplete">Ready to edit</span>
                  <span v-else-if="!video.data.tagsComplete">Choose tags</span>
                  <span v-else-if="!video.data.descriptionComplete">Write description</span>
                  <span v-else-if="!video.data.uploadComplete">Upload to YouTube</span>
                  <span v-else-if="!video.data.promoteComplete">Ready to promote</span>
                  <span v-else-if="!video.data.publishComplete">Ready to publish</span>
                  <span v-else-if="!video.data.engageComplete">Engage comments</span>
                  •
                  <span>In {{ -video.daysFromPublish }} days</span>
                </div>
                <div class="long-video-metadata">
                  <img
                    class="channel-icon"
                    :src="youtube.channelSnippet.thumbnails.medium.url"
                  />
                  <span class="long-video-channel-name">{{ youtube.channelSnippet.title }}</span>
                </div>
                <div class="long-video-metadata" v-if="video.data.description">
                  {{ video.data.description }}
                </div>
                <div class="long-video-metadata" v-else>
                  The description will go
                  here...
                </div>
              </div>
            </router-link>
          </div>
        </div>
        <div v-else>
          <h4>No videos planned!</h4>
          <p>Go to the Strategy page to discover a video topic to plan.</p>
          <router-link to="/strategy" class="btn btn-sales">Plan Video</router-link>
        </div>
      </a-tab-pane>
      <a-tab-pane tab="Upcoming" key="2">
        <div v-if="upcomingVideos.length" class="long-videos">
          <div class="long-video-section">
            <router-link
              v-for="video in upcomingVideos"
              :key="video.videoID"
              :to="{
                    name: 'video-details',
                    params: { video, videoID: video.videoID },
                  }"
              class="long-video-container"
            >
              <div class="long-thumbnail">
                <img :src="video.data.thumbnail" class="long-thumbnail-image" />
              </div>
              <div class="long-video-right-section">
                <div class="long-video-title">{{ video.data.title }}</div>
                <div class="video-metadata">
                  <span v-if="!video.data.titleComplete">Create title</span>
                  <span v-else-if="!video.data.thumbnailComplete">Create thumbnail</span>
                  <span v-else-if="!video.data.scriptComplete">Write script</span>
                  <span v-else-if="!video.data.filmComplete">Ready to film</span>
                  <span v-else-if="!video.data.editComplete">Ready to edit</span>
                  <span v-else-if="!video.data.tagsComplete">Choose tags</span>
                  <span v-else-if="!video.data.descriptionComplete">Write description</span>
                  <span v-else-if="!video.data.uploadComplete">Upload to YouTube</span>
                  <span v-else-if="!video.data.promoteComplete">Ready to promote</span>
                  <span v-else-if="!video.data.publishComplete">Ready to publish</span>
                  <span v-else-if="!video.data.engageComplete">Engage comments</span>
                  •
                  <span>In {{ -video.daysFromPublish }} days</span>
                </div>
                <div class="long-video-metadata">
                  <img
                    class="channel-icon"
                    :src="youtube.channelSnippet.thumbnails.medium.url"
                  />
                  <span class="long-video-channel-name">{{ youtube.channelSnippet.title }}</span>
                </div>
                <div class="long-video-metadata" v-if="video.data.description">
                  {{ video.data.description }}
                </div>
                <div class="long-video-metadata" v-else>
                  The description will go
                  here...
                </div>
              </div>
            </router-link>
          </div>
        </div>
        <div v-else>
          <h4>No videos planned!</h4>
          <p>Go to the Strategy page to discover a video topic to plan.</p>
          <router-link to="/strategy" class="btn btn-sales">Plan Video</router-link>
        </div>
      </a-tab-pane>
      <a-tab-pane tab="Published" key="3">
        <div v-if="publishedVideos.length" class="long-videos">
          <div class="long-video-section">
            <router-link
              v-for="video in publishedVideos"
              :key="video.videoID"
              :to="{
                    name: 'video-details',
                    params: { video, videoID: video.videoID },
                  }"
              class="long-video-container"
            >
              <div class="long-thumbnail">
                <img :src="video.data.thumbnail" class="long-thumbnail-image" />
              </div>
              <div class="long-video-right-section">
                <div class="long-video-title">{{ video.data.title }}</div>
                <div class="video-metadata">
                  <span v-if="!video.data.titleComplete">Create title</span>
                  <span v-else-if="!video.data.thumbnailComplete">Create thumbnail</span>
                  <span v-else-if="!video.data.scriptComplete">Write script</span>
                  <span v-else-if="!video.data.filmComplete">Ready to film</span>
                  <span v-else-if="!video.data.editComplete">Ready to edit</span>
                  <span v-else-if="!video.data.tagsComplete">Choose tags</span>
                  <span v-else-if="!video.data.descriptionComplete">Write description</span>
                  <span v-else-if="!video.data.uploadComplete">Upload to YouTube</span>
                  <span v-else-if="!video.data.promoteComplete">Ready to promote</span>
                  <span v-else-if="!video.data.publishComplete">Ready to publish</span>
                  <span v-else-if="!video.data.engageComplete">Engage comments</span>
                  •
                  <span>In {{ -video.daysFromPublish }} days</span>
                </div>
                <div class="long-video-metadata">
                  <img
                    class="channel-icon"
                    :src="youtube.channelSnippet.thumbnails.medium.url"
                  />
                  <span class="long-video-channel-name">{{ youtube.channelSnippet.title }}</span>
                </div>
                <div class="long-video-metadata" v-if="video.data.description">
                  {{ video.data.description }}
                </div>
                <div class="long-video-metadata" v-else>
                  The description will go
                  here...
                </div>
              </div>
            </router-link>
          </div>
        </div>
        <div v-else>
          <h4>No videos published!</h4>
          <p>You haven't published any videos planned with PlannerVid.</p>
        </div>
      </a-tab-pane>
    </a-tabs>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'list',
  data() {
    return {
      allVideos: [],
      upcomingVideos: [],
      publishedVideos: [],
    }
  },
  computed: {
    ...mapState(['creator']),
    ...mapState(['youtube']),
  },
  created() {
    this.filterUpcoming()
    this.filterPublished()
  },
  methods: {
    filterUpcoming() {
      const upcoming = this.creator.videos.videos.filter(obj => {
        return !obj.data.publishComplete
      })
      this.upcomingVideos = upcoming
    },
    filterPublished() {
      const published = this.creator.videos.videos.filter(obj => {
        return obj.data.publishComplete
      })
      this.publishedVideos = published
    },
  },
}
</script>

<style lang="scss" module>
@import "./style.module.scss";
</style>
